import { Box, Typography } from '@mui/material';
import React, { type ReactNode, useId } from 'react';

export function SubscriptionSettingsSection({
	title,
	children,
	fullWidth = false,
}: {
	title: string;
	children: ReactNode;
	fullWidth?: boolean;
}) {
	const titleId = useId();
	return (
		<Box
			component='section'
			aria-labelledby={titleId}
			sx={{
				minWidth: 0,
				gridColumn: fullWidth ? '1 / -1' : undefined,
				border: 1,
				borderColor: 'divider',
				borderRadius: 1,
				bgcolor: 'background.paper',
				overflow: 'hidden',
			}}
		>
			<Typography
				id={titleId}
				component='h2'
				variant='subtitle1'
				sx={{
					px: 2.5,
					py: 1.5,
					fontWeight: 600,
					bgcolor: 'action.hover',
					borderBottom: 1,
					borderColor: 'divider',
				}}
			>
				{title}
			</Typography>
			<Box sx={{ px: 2.5 }}>{children}</Box>
		</Box>
	);
}

export function SubscriptionSettingsRow({ children }: { children: ReactNode }) {
	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'minmax(0, 1fr) minmax(0, 1fr)' },
				alignItems: 'center',
				gap: { xs: 1, sm: 2 },
				minHeight: 64,
				py: 1.5,
				borderBottom: 1,
				borderColor: 'divider',
				'&:last-child': { borderBottom: 0 },
				'& > *': { minWidth: 0 },
				'& strong': { fontSize: '0.875rem', fontWeight: 600 },
				'& .MuiInputBase-root': { width: '100%', fontSize: '0.875rem' },
				'& .MuiSelect-select, & .MuiInputBase-input': { py: 1.25 },
			}}
		>
			{children}
		</Box>
	);
}
